export const jsonAuthHeaders = (token: string) => ({
  Accept: 'application/json',
  'X-AUTH-TOKEN': token || '',
});

export const basicAuthHeaders = (token: string) => ({
  Accept: 'application/json',
  'X-AUTH-TOKEN': token || '',
});
